import _assertThisInitialized from "/Users/blainelewis/projects/blainelewis1.github.io/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/blainelewis/projects/blainelewis1.github.io/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/blainelewis/projects/blainelewis1.github.io/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/blainelewis/projects/blainelewis1.github.io/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _slicedToArray from "/Users/blainelewis/projects/blainelewis1.github.io/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/Users/blainelewis/projects/blainelewis1.github.io/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/blainelewis/projects/blainelewis1.github.io/node_modules/@babel/runtime/helpers/esm/createClass";
import _asyncToGenerator from "/Users/blainelewis/projects/blainelewis1.github.io/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import _regeneratorRuntime from "/Users/blainelewis/projects/blainelewis1.github.io/node_modules/@babel/runtime/regenerator";
import { require as requireDefault } from "d3-require";
import { arrow as _arrow, d3Dsv } from "./dependencies.js";
import { SQLiteDatabaseClient } from "./sqlite.js";
import jszip from "./zip.js";

function remote_fetch(_x) {
  return _remote_fetch.apply(this, arguments);
}

function _remote_fetch() {
  _remote_fetch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(file) {
    var response;
    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            _context18.t0 = fetch;
            _context18.next = 3;
            return file.url();

          case 3:
            _context18.t1 = _context18.sent;
            _context18.next = 6;
            return (0, _context18.t0)(_context18.t1);

          case 6:
            response = _context18.sent;

            if (response.ok) {
              _context18.next = 9;
              break;
            }

            throw new Error("Unable to load file: ".concat(file.name));

          case 9:
            return _context18.abrupt("return", response);

          case 10:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18);
  }));
  return _remote_fetch.apply(this, arguments);
}

function dsv(_x2, _x3) {
  return _dsv.apply(this, arguments);
}

function _dsv() {
  _dsv = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(file, delimiter) {
    var _ref,
        _ref$array,
        array,
        _ref$typed,
        typed,
        _yield$Promise$all5,
        _yield$Promise$all6,
        text,
        d3,
        _args19 = arguments;

    return _regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            _ref = _args19.length > 2 && _args19[2] !== undefined ? _args19[2] : {}, _ref$array = _ref.array, array = _ref$array === void 0 ? false : _ref$array, _ref$typed = _ref.typed, typed = _ref$typed === void 0 ? false : _ref$typed;
            _context19.next = 3;
            return Promise.all([file.text(), requireDefault(d3Dsv.resolve())]);

          case 3:
            _yield$Promise$all5 = _context19.sent;
            _yield$Promise$all6 = _slicedToArray(_yield$Promise$all5, 2);
            text = _yield$Promise$all6[0];
            d3 = _yield$Promise$all6[1];
            return _context19.abrupt("return", (delimiter === "\t" ? array ? d3.tsvParseRows : d3.tsvParse : array ? d3.csvParseRows : d3.csvParse)(text, typed && d3.autoType));

          case 8:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19);
  }));
  return _dsv.apply(this, arguments);
}

var AbstractFile = /*#__PURE__*/function () {
  function AbstractFile(name) {
    _classCallCheck(this, AbstractFile);

    Object.defineProperty(this, "name", {
      value: name,
      enumerable: true
    });
  }

  _createClass(AbstractFile, [{
    key: "blob",
    value: function () {
      var _blob = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return remote_fetch(this);

              case 2:
                return _context.abrupt("return", _context.sent.blob());

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function blob() {
        return _blob.apply(this, arguments);
      }

      return blob;
    }()
  }, {
    key: "arrayBuffer",
    value: function () {
      var _arrayBuffer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return remote_fetch(this);

              case 2:
                return _context2.abrupt("return", _context2.sent.arrayBuffer());

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function arrayBuffer() {
        return _arrayBuffer.apply(this, arguments);
      }

      return arrayBuffer;
    }()
  }, {
    key: "text",
    value: function () {
      var _text = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return remote_fetch(this);

              case 2:
                return _context3.abrupt("return", _context3.sent.text());

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function text() {
        return _text.apply(this, arguments);
      }

      return text;
    }()
  }, {
    key: "json",
    value: function () {
      var _json = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return remote_fetch(this);

              case 2:
                return _context4.abrupt("return", _context4.sent.json());

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function json() {
        return _json.apply(this, arguments);
      }

      return json;
    }()
  }, {
    key: "stream",
    value: function () {
      var _stream = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return remote_fetch(this);

              case 2:
                return _context5.abrupt("return", _context5.sent.body);

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function stream() {
        return _stream.apply(this, arguments);
      }

      return stream;
    }()
  }, {
    key: "csv",
    value: function () {
      var _csv = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(options) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", dsv(this, ",", options));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function csv(_x4) {
        return _csv.apply(this, arguments);
      }

      return csv;
    }()
  }, {
    key: "tsv",
    value: function () {
      var _tsv = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(options) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", dsv(this, "\t", options));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function tsv(_x5) {
        return _tsv.apply(this, arguments);
      }

      return tsv;
    }()
  }, {
    key: "image",
    value: function () {
      var _image = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var _this = this;

        var url;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.url();

              case 2:
                url = _context8.sent;
                return _context8.abrupt("return", new Promise(function (resolve, reject) {
                  var i = new Image();

                  if (new URL(url, document.baseURI).origin !== new URL(location).origin) {
                    i.crossOrigin = "anonymous";
                  }

                  i.onload = function () {
                    return resolve(i);
                  };

                  i.onerror = function () {
                    return reject(new Error("Unable to load file: ".concat(_this.name)));
                  };

                  i.src = url;
                }));

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function image() {
        return _image.apply(this, arguments);
      }

      return image;
    }()
  }, {
    key: "arrow",
    value: function () {
      var _arrow2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var _yield$Promise$all, _yield$Promise$all2, Arrow, response;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return Promise.all([requireDefault(_arrow.resolve()), remote_fetch(this)]);

              case 2:
                _yield$Promise$all = _context9.sent;
                _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
                Arrow = _yield$Promise$all2[0];
                response = _yield$Promise$all2[1];
                return _context9.abrupt("return", Arrow.Table.from(response));

              case 7:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function arrow() {
        return _arrow2.apply(this, arguments);
      }

      return arrow;
    }()
  }, {
    key: "sqlite",
    value: function () {
      var _sqlite = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt("return", SQLiteDatabaseClient.open(remote_fetch(this)));

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function sqlite() {
        return _sqlite.apply(this, arguments);
      }

      return sqlite;
    }()
  }, {
    key: "zip",
    value: function () {
      var _zip = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var _yield$Promise$all3, _yield$Promise$all4, JSZip, buffer;

        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return Promise.all([jszip(requireDefault), this.arrayBuffer()]);

              case 2:
                _yield$Promise$all3 = _context11.sent;
                _yield$Promise$all4 = _slicedToArray(_yield$Promise$all3, 2);
                JSZip = _yield$Promise$all4[0];
                buffer = _yield$Promise$all4[1];
                _context11.t0 = ZipArchive;
                _context11.next = 9;
                return JSZip.loadAsync(buffer);

              case 9:
                _context11.t1 = _context11.sent;
                return _context11.abrupt("return", new _context11.t0(_context11.t1));

              case 11:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function zip() {
        return _zip.apply(this, arguments);
      }

      return zip;
    }()
  }]);

  return AbstractFile;
}();

var FileAttachment = /*#__PURE__*/function (_AbstractFile) {
  _inherits(FileAttachment, _AbstractFile);

  var _super = _createSuper(FileAttachment);

  function FileAttachment(url, name) {
    var _this2;

    _classCallCheck(this, FileAttachment);

    _this2 = _super.call(this, name);
    Object.defineProperty(_assertThisInitialized(_this2), "_url", {
      value: url
    });
    return _this2;
  }

  _createClass(FileAttachment, [{
    key: "url",
    value: function () {
      var _url = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this._url;

              case 2:
                _context12.t0 = _context12.sent;
                return _context12.abrupt("return", _context12.t0 + "");

              case 4:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function url() {
        return _url.apply(this, arguments);
      }

      return url;
    }()
  }]);

  return FileAttachment;
}(AbstractFile);

export function NoFileAttachments(name) {
  throw new Error("File not found: ".concat(name));
}
export default function FileAttachments(resolve) {
  return Object.assign(function (name) {
    var url = resolve(name += ""); // Returns a Promise, string, or null.

    if (url == null) throw new Error("File not found: ".concat(name));
    return new FileAttachment(url, name);
  }, {
    prototype: FileAttachment.prototype
  } // instanceof
  );
}
export var ZipArchive = /*#__PURE__*/function () {
  function ZipArchive(archive) {
    _classCallCheck(this, ZipArchive);

    Object.defineProperty(this, "_", {
      value: archive
    });
    this.filenames = Object.keys(archive.files).filter(function (name) {
      return !archive.files[name].dir;
    });
  }

  _createClass(ZipArchive, [{
    key: "file",
    value: function file(path) {
      var object = this._.file(path += "");

      if (!object || object.dir) throw new Error("file not found: ".concat(path));
      return new ZipArchiveEntry(object);
    }
  }]);

  return ZipArchive;
}();

var ZipArchiveEntry = /*#__PURE__*/function (_AbstractFile2) {
  _inherits(ZipArchiveEntry, _AbstractFile2);

  var _super2 = _createSuper(ZipArchiveEntry);

  function ZipArchiveEntry(object) {
    var _this3;

    _classCallCheck(this, ZipArchiveEntry);

    _this3 = _super2.call(this, object.name);
    Object.defineProperty(_assertThisInitialized(_this3), "_", {
      value: object
    });
    Object.defineProperty(_assertThisInitialized(_this3), "_url", {
      writable: true
    });
    return _this3;
  }

  _createClass(ZipArchiveEntry, [{
    key: "url",
    value: function () {
      var _url2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                return _context13.abrupt("return", this._url || (this._url = this.blob().then(URL.createObjectURL)));

              case 1:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function url() {
        return _url2.apply(this, arguments);
      }

      return url;
    }()
  }, {
    key: "blob",
    value: function () {
      var _blob2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                return _context14.abrupt("return", this._.async("blob"));

              case 1:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function blob() {
        return _blob2.apply(this, arguments);
      }

      return blob;
    }()
  }, {
    key: "arrayBuffer",
    value: function () {
      var _arrayBuffer2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                return _context15.abrupt("return", this._.async("arraybuffer"));

              case 1:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function arrayBuffer() {
        return _arrayBuffer2.apply(this, arguments);
      }

      return arrayBuffer;
    }()
  }, {
    key: "text",
    value: function () {
      var _text2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                return _context16.abrupt("return", this._.async("text"));

              case 1:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function text() {
        return _text2.apply(this, arguments);
      }

      return text;
    }()
  }, {
    key: "json",
    value: function () {
      var _json2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.t0 = JSON;
                _context17.next = 3;
                return this.text();

              case 3:
                _context17.t1 = _context17.sent;
                return _context17.abrupt("return", _context17.t0.parse.call(_context17.t0, _context17.t1));

              case 5:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function json() {
        return _json2.apply(this, arguments);
      }

      return json;
    }()
  }]);

  return ZipArchiveEntry;
}(AbstractFile);